import { TIMER } from "../../Gameplay";
import { DecoFrameEnts } from "./DecoFrameEntities";



export class DecoTypeSettings {
    /**
     * (RO) Zaklad jmena pro jednotlive snimky
     */
    get frameKeyBase(): string { return this._frameKeyBase; }
    private _frameKeyBase: string;
    /**
     * (RO) Rychlost animace grafiky (delka 1 snimku v ms)
     */
    get frameTime(): number { return this._frameTime; }
    private _frameTime: number;
    /**
     * (RO) Cekovy pocet snimu animace
     */
    get frameCnt(): number { return this._frameCnt; }
    private _frameCnt: number;
    /**
     * (RO) Pocet pixelu na 1 metr
     */
    get pixelsPerUnit(): number { return this._pixelsPerUnit; }
    private _pixelsPerUnit: number;
    /**
     * (RO) Rotace entit
     */
    get rotation(): pc.Vec3 { return this._rotation; }
    private _rotation: pc.Vec3;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(frameKeyBase: string, frameCnt: number, fps: number, pixelsPerUnit: number, rotation: pc.Vec3 = new pc.Vec3()) {
        this._frameKeyBase = frameKeyBase;
        this._frameCnt = frameCnt;
        this._frameTime = 1000 / fps;
        this._pixelsPerUnit = pixelsPerUnit;
        this._rotation = rotation;
    }
}



class AnimController {
    /**
     * Nastaveni typu dekorace
     */
    private _typeSettings: DecoTypeSettings;
    /**
     * Cas, kdy ma dojit k prepnuti na dalsi snimek
     */
    private _nextFrameTime: number;
    /**
     * (RO) Aktualni index zakladniho snimku
     */
    get baseFrameId(): number { return this._baseFrameId; }
    private _baseFrameId: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(typeSettings: DecoTypeSettings) {
        this._typeSettings = typeSettings;
        this.reset();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        this._baseFrameId = 0;
        this._nextFrameTime = TIMER.time + this._typeSettings.frameTime;
    }

    //-------------------------------------------------------------------------
    /**
     * 
     * @returns True, pokud je cas na zmenu snimku
     */
    //-------------------------------------------------------------------------
    update(): boolean {
        if (this._typeSettings.frameCnt > 1) {
            if (TIMER.time >= this._nextFrameTime) {
                this._nextFrameTime += this._typeSettings.frameTime;

                if (this._baseFrameId-- == 0)
                    this._baseFrameId = this._typeSettings.frameCnt - 1;

                return true;
            }
        }

        return false;
    }
}



export class DecoType {
    private _animCtrl: AnimController;

    /**
     * (RO) Entity pro jednotlive snimky animace [inex_snimku][]
     */
    get frameEnts(): DecoFrameEnts[] { return this._frameEnts; }
    private _frameEnts: DecoFrameEnts[];
    /**
     * (RO) Pozice entit pro jednotlive snimky animace [index_snimku][]
     */
    get frameEntPositions(): pc.Vec3[][] { return this._frameEntPositions; }
    private _frameEntPositions: pc.Vec3[][];
    /**
     * True, pokud je typ dekorace povolen
     */
    get isActive(): boolean { return this._active; }
    set isActive(val: boolean) {
        if (val != this._active) {
            this._active = val;

            this._frameEnts.forEach((ents: DecoFrameEnts): void => {
                ents.enabled = val;
            });
        }
    }
    private _active: boolean;

    //-------------------------------------------------------------------------
    /**
     * 
     * @param settings Nastaveni typu dekorace
     * @param entityCnt Pocet entit pro tento typ dekorace
     * @param container 
     * @param batchGroupId 
     */
    //-------------------------------------------------------------------------
    constructor(settings: DecoTypeSettings, entityCnt: number, material: pc.StandardMaterial, container: pc.GraphNode, batchGroupId: number) {
        // Ovladac animace
        this._animCtrl = new AnimController(settings);

        // Pocet entit od kazdeho snimku
        let entPerFrameCnt = Math.ceil(entityCnt / settings.frameCnt);

        // Vytvorit entity pro jednotlive snimky
        let frameId = settings.frameCnt;

        this._frameEnts = [];
        this._frameEntPositions = [];

        while (frameId-- != 0) {
            this._frameEnts[frameId] = new DecoFrameEnts(settings.frameKeyBase + frameId, entPerFrameCnt, material, container, batchGroupId, settings.pixelsPerUnit, settings.rotation);

            let positions: pc.Vec3[] = [];

            for (let i = 0; i < entPerFrameCnt; i++)
                positions.push(new pc.Vec3(0, -2, 0));

            this._frameEntPositions[frameId] = positions;
        }

        this._active = true;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        this._animCtrl.reset();
        this.updateFrames();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): boolean {
        if (this._active && this._animCtrl.update()) {
            this.updateFrames();
            return true;
        }

        return false;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private updateFrames(): void {
        let frameCnt = this._frameEnts.length;

        for (let frameId = 0; frameId < frameCnt; frameId++) {
            let groupId = frameId + this._animCtrl.baseFrameId;

            if (groupId >= frameCnt)
                groupId -= frameCnt;

            this._frameEnts[frameId].repositionEntities(this._frameEntPositions[groupId]);
        }
    }
}

